import React from 'react';
import './App.css';
import MainLayout from './pages/MainLayout';

const App: React.FC = () => {
  return <MainLayout/>;
};

export default App;
